import React from "react";
import "./App.css";
import "./styles/main.scss";
import { BodySection } from "./styles/component/style";
import AppRouter from "./AppRoutes";
import Providers from "./providers/Providers";
import Loader from "./components/common/Loader/Loader";
import AlertWrapper from "./components/common/Alert/AlertWrapper";
import SessionLogout from "./components/common/SessionLogout";
import GlobalStyles from "./styles/GlobalStyles";

function App() {
  return (
    <Providers>
      <GlobalStyles />
      <BodySection>
        <Loader />
        <AlertWrapper />
        <AppRouter />
      </BodySection>
      <SessionLogout />
      {/* </Layout> */}
    </Providers>
  );
}

export default App;
